var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isErrorOnLoad
      ? _c("div", { staticClass: "notification is-danger is-light" }, [
          _vm._v(" " + _vm._s(_vm.message) + " "),
        ])
      : _vm._e(),
    _vm.isActive
      ? _c(
          "div",
          [
            _vm._m(0),
            _c("form-reset-password", {
              attrs: {
                fetching: _vm.fetching,
                message: _vm.message,
                "message-type": _vm.messageType,
              },
              on: { submit: _vm.complete },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.isSuccess
      ? _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "notification is-success is-light" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.message) + " ")]),
          ]),
          _c("p", [_vm._v("Please login.")]),
          _c(
            "p",
            [
              _c(
                "router-link",
                {
                  staticClass: "button is-primary",
                  attrs: { to: { name: "Login" } },
                },
                [_vm._v("Login")]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h1", { staticClass: "title is-bold" }, [_vm._v("Reset password")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }